import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CheckoutStepComponentDef } from '@df/checkout/checkout-step.component.def';
@Component({
    selector: 'checkout-step',
    templateUrl: './checkout-step.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [{ provide: CheckoutStepComponentDef, useExisting: CheckoutStepComponent }]
})
export class CheckoutStepComponent extends CheckoutStepComponentDef {
    /**
     * Class constructor
     */

    get hide(): boolean {
        if (this.isCurrent) {
            return false;
        }
        const index = this.checkoutFormComponent.getStepIndex(this);
        return index > this.checkoutFormComponent.currentStepIndex;
    }
}
